import clsx from 'clsx';
import type * as React from 'react';

import { useFieldContext } from './FieldContext';
import { useFieldController } from './FieldControllerContext';

export type FieldErrorProps = React.HTMLAttributes<HTMLDivElement>;

/**
 * Display an error message for a form control.
 */
export function FieldError({ className, id: propId, children, ...props }: FieldErrorProps) {
    const controller = useFieldController();
    const message = children ?? controller?.fieldState.error?.message;
    const ctx = useFieldContext();
    if (message) {
        return (
            <div
                id={propId ?? ctx?.errorId}
                className={clsx('text-ui-small text-danger', className)}
                {...props}
            >
                {message}
            </div>
        );
    }
    return null;
}
